import Sp1 from "./steps/sp1";
import SpAddress from "./steps/spAddress";
import SpCancellation from "./steps/spCancellation";
import SpLicense from "./steps/spLicense";
import SpOther from "./steps/spOther";
import SpRegistration from "./steps/spRegistration";
import SpUse from "./steps/spUse";
import SpVehicle from "./steps/spVehicle";
import SupportStep from "../../enums/SupportStep";
import SpComplete from "./steps/spComplete";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import StepNavDisplay from "../../components/support/StepNavDisplay";
import PageContentStack from "../../../../shared/components/PageContentStack";

const stepComponents = {
  [SupportStep.SP1]: Sp1,
  [SupportStep.SP_ADDRESS]: SpAddress,
  [SupportStep.SP_CANCELLATION]: SpCancellation,
  [SupportStep.SP_LICENSE]: SpLicense,
  [SupportStep.SP_OTHER]: SpOther,
  [SupportStep.SP_REGISTRATION]: SpRegistration,
  [SupportStep.SP_USE]: SpUse,
  [SupportStep.SP_VEHICLE]: SpVehicle,
  [SupportStep.SP_COMPLETE]: SpComplete,
};

const AllSupportSteps = () => {
  const spCurrentStep = useAppStateStore((state) => state.spCurrentStep);
  const StepComponent = stepComponents[spCurrentStep] || null;
  return (
    <PageContentStack className="tw-items-stretch">
      <StepNavDisplay />
      {StepComponent && <StepComponent />}
    </PageContentStack>
  );
};

export default AllSupportSteps;
